import { FuelDivider, FuelSkeleton } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { DS_TOKENS } from 'constants/styled.contants';
import React from 'react';

const Loading = () => (
  <FuelFlex defaultProps={{ flexDirection: 'column', width: '100%' }} testId="desktop-loading-state">
    <FuelFlex defaultProps={{ gap: 'km4' }}>
      <FuelSkeleton shape="circle" size="giant" />
      <FuelFlex defaultProps={{ flexDirection: 'column', justifyContent: 'center', gap: 'km2' }}>
        <FuelSkeleton shape="pill" size="custom" height="20px" width="150px" />
        <FuelSkeleton shape="pill" size="custom" height="12px" width="150px" />
        <FuelSkeleton shape="pill" size="custom" height="12px" width="150px" />
      </FuelFlex>
    </FuelFlex>
    <FuelFlex
      defaultProps={{
        justifyContent: 'space-between',
        customMargin: `${DS_TOKENS.spacing.km5} 0 ${DS_TOKENS.spacing.km6}`,
      }}
    >
      <FuelSkeleton shape="square" size="custom" width="87px" height="56px" />
      <FuelDivider size="default" orientation="vertical" />
      <FuelSkeleton shape="square" size="custom" width="87px" height="56px" />
      <FuelDivider size="default" orientation="vertical" />
      <FuelSkeleton shape="square" size="custom" width="87px" height="56px" />
    </FuelFlex>
    <FuelFlex
      defaultProps={{ justifyContent: 'space-between', gap: 'km4', customMargin: `${DS_TOKENS.spacing.km1} 0 0` }}
    >
      <FuelSkeleton shape="square" size="custom" width="100%" height="40px" />
      <FuelSkeleton shape="square" size="custom" width="100%" height="40px" />
    </FuelFlex>
  </FuelFlex>
);

export default Loading;
